<template>
  <KTCodePreview>
    <template v-slot:preview>
      <b-row>
        <b-col>
          <b-form-group label-cols-sm="4" label-cols-lg="3" content-cols-sm content-cols-lg="8" id="material_label"
                        label="Alat/ Instrumentasi :" label-for="material">
            <b-form-input id="material" type="text" v-model="$v.alat.$model"
                          :state="validateState('alat')"></b-form-input>
            <b-form-invalid-feedback id="alat_feedback">
              Nama Alat Harus Terisi.
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-cols-sm="4" label-cols-lg="3" content-cols-sm content-cols-lg="8" id="material_label"
                        label="Kalibrasi :" label-for="material">
            <b-form-input type="text" v-model="$v.kalibrasi.$model" :state="validateState('kalibrasi')"></b-form-input>
            <b-form-invalid-feedback id="kalibrasi_feedback">
              Kalibrasi Harus Terisi.
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-cols-sm="4" label-cols-lg="3" content-cols-sm content-cols-lg="8" label="Parameter :"
                        label-for="material">
            <b-form-input type="text" v-model="$v.parameter.$model" :state="validateState('parameter')"></b-form-input>
            <b-form-invalid-feedback id="parameter_feedback">
              Parameter Harus Terisi.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-cols-sm="4" label-cols-lg="3" content-cols-sm content-cols-lg="8" label="Waktu :"
                        label-for="material">
            <template v-slot:description>
              <div v-show="showDateMessage" class="text-warning">
                Sudah ada data pengukuran pada tanggal tersebut, data lama akan di replace
              </div>
            </template>
            <b-form-input @input="dateChange()" type="date" v-model="$v.tanggal.$model"
                          :state="validateState('tanggal')"></b-form-input>
            <b-form-invalid-feedback id="tanggal_feedback">
              Tanggal Harus Terisi.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>&nbsp;</b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-img fluid :src="urlStorage + '/file/condition_monitoring/' + sketsa"></b-img>
        </b-col>
      </b-row>
      <b-row>
        <b-col>&nbsp;</b-col>
      </b-row>
      <b-row>
        <b-col>Hasil Pengukuran</b-col>
      </b-row>
      <b-row>
        <b-col>
          <hr />
        </b-col>
      </b-row>
      <b-row>
        <b-col v-for="(row, index) in titikUkur" md="4" :key="index">
          <b-form-group label-cols-sm="4" label-cols-lg="2" content-cols-sm content-cols-lg="8" id="material_label"
                        :label="row.nama_titik_ukur" label-for="material">
            <b-form-input id="material" type="text" v-model="titikUkur[index].nilai_titik_ukur"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <small>Harap download template titik ukur terlebih dahulu
            <a @click="exportTemplateTitikUkur">disini</a></small>
        </b-col>
        <b-col md="6">
          <b-form-file v-model="import_titik_ukur" placeholder="import excel titik ukur..."
                       drop-placeholder="import excel titik ukur..." accept=".xlsx"></b-form-file>
        </b-col>
        <b-col md="4">
          <b-button variant="outline-success" size="sm" @click="importTitikUkur">
            <i class="flaticon2-check-mark text-success text-sm"></i> Unggah Sekarang
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <hr />
        </b-col>
      </b-row>
      <b-row>
        <b-col><b-form-group label-cols-sm="3" label-cols-lg="3" content-cols-sm content-cols-lg="9" id="keterangan"
                             label="Keterangan :" label-for="material">
          <b-form-input id="keterangan" type="text" v-model="$v.keterangan.$model"
                        :state="validateState('keterangan')"></b-form-input>
          <b-form-invalid-feedback id="keterangan_feedback">
            Keterangan Harus Terisi.
          </b-form-invalid-feedback>
        </b-form-group></b-col>
        <b-col>&nbsp;</b-col>
      </b-row>
      <!-- <b-row>
            <b-col>
              <b-button @click="save()">Save</b-button>&nbsp;
              <b-button @click="save()">Back</b-button>
            </b-col>
          </b-row> -->
    </template>
  </KTCodePreview>
</template>
<script>
import KTCodePreview from '@/view/content/CodePreview.vue'
import ApiService from '@/core/services/api.service'
import JwtService from '@/core/services/jwt.service'
import axios from 'axios'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import $ from 'jquery'
export default {
  mixins: [validationMixin],
  data() {
    return {
      showDateMessage: false,
      titikUkur: [],
      alat: '',
      kalibrasi: '',
      parameter: '',
      tanggal: '',
      sketsa: '',
      keterangan: '',
      import_titik_ukur: null,
      urlStorage: ApiService.urlStorage(),
    }
  },
  validations: {
    alat: { required },
    kalibrasi: { required },
    tanggal: { required },
    parameter: { required },
    keterangan: { required },
  },
  created() {
    this.getTitikUkur()
  },
  methods: {
    makeToast(variant = null, $content) {
      this.$bvToast.toast($content, {
        title: `${variant || 'default'}`,
        variant: variant,
        toaster: 'b-toaster-top-center',
        solid: true,
      })
    },
    importTitikUkur() {
      if (!this.import_titik_ukur) {
        this.makeToast('danger', 'Tidak ada file excel terpilih')
        return
      }

      var self = this
      self.loading = true

      const import_titik_ukur = this.import_titik_ukur

      const dataku = new FormData()
      dataku.append('import_titik_ukur', import_titik_ukur)

      var urlApi = ApiService.urlApi()

      $.ajax({
        url: urlApi + '/report/condition_monitoring/import_template_titik_ukur',
        data: dataku,
        cache: false,
        contentType: false,
        processData: false,
        method: 'POST',
        headers: ApiService.headerAPi(),
        success: function (response) {
          if (response.status == 'ok') {
            self.makeToast('success', 'Data berhasil ditampilkan')
            self.$bvModal.hide('info-modal')
            const rTitikUkur = response.data[0]
            for (var item in rTitikUkur) {
              self.titikUkur[item].nilai_titik_ukur = rTitikUkur[item].nilai_titik_ukur
              //console.log(rTitikUkur[item].nilai_titik_ukur)
            }
          }
        },
      })
    },
    async dateChange() {
      const response = await ApiService.post('/report/condition-monitoring-detail/check-exist', {
        tanggal: this.tanggal,
        id_condition_monitoring: this.$route.params.id,
      })
      if (response.status == 200) {
        if (response.data.status == 'exist') {
          this.showDateMessage = true
        } else {
          this.showDateMessage = false
        }
        // this.$router.push(`/report/conditional_report/detail/${this.$route.params.id}`)
      }
      // console.log(this.tanggal)
    },
    validateState(name) {
      const { $dirty, $error } = this.$v[name]
      return $dirty ? !$error : null
    },
    exportTemplateTitikUkur() {
      const self = this
      axios({
        method: 'get',
        responseType: 'arraybuffer',
        url: '/report/condition_monitoring/export_template_titik_ukur/' + this.$route.params.id,
        headers: {
          Accept: 'multipart/form-data',
          Authorization: 'Bearer ' + JwtService.getToken(),
        },
      }).then(function (response) {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]))
        var fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', `template_titik_ukur_${self.$route.params.id}.xlsx`)
        document.body.appendChild(fileLink)
        fileLink.click()
      })
    },
    async getTitikUkur() {
      const response = await ApiService.get(`/titik-ukur/${this.$route.params.id}`)
      if (response.data.data.length > 0) {
        this.titikUkur = response.data.data[0].titik_ukur
        this.sketsa = response.data.data[0].sketsa
      }
    },
    async save() {
      this.$v.$touch()
      if (this.$v.$anyError) {
        return false
      }
      const response = await ApiService.post('/report/condition-monitoring-detail', {
        alat: this.alat,
        kalibrasi: this.kalibrasi,
        parameter: this.parameter,
        tanggal: this.tanggal,
        titikUkur: this.titikUkur,
        keterangan: this.keterangan,
        id_condition_monitoring: this.$route.params.id,
      })
      if (response.status == 200) {
        this.$router.push(`/report/conditional_report/detail/${this.$route.params.id}`)
      }
    },
  },
  components: {
    KTCodePreview,
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors,
    }),
  },
}
</script>
